export default __webpack_public_path__ + "static/media/Vinci Sans Bold.6b3cd6ef.ttf";